<template>
  <li class="section-sub-menu">
    <a class="level-name" data-toggle="collapse" :data-target="`#${level.key}`">
      {{ level.name }}
      <i class="fa fa-fw fa-angle-down pull-right"></i>
    </a>
    <ul :class="classes" :id="level.key">
      <li
        v-for="section in level.sections"
        :key="section.key"
        :class="{active: currentSection.key === section.key}"
      >
        <a @click="setSection(section)">{{ section.displayName }}</a>
      </li>
      <SectionSubMenu
        v-for="subSectionLevel in level.subSections"
        :key="subSectionLevel.name"
        :level="subSectionLevel"
      />
    </ul>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    level: { type: Object }
  },
  components: {
    SectionSubMenu: () => import('./SectionSubMenu.vue')
  },
  computed: {
    ...mapGetters(['currentSection']),
    classes() {
      return {
        collapse: this.level.key !== 'Settings'
      }
    }
  },
  methods: {
    setSection(section) {
      this.$store.commit('setSectionSelected')
      this.$store.commit('setCurrentSection', section)
    }
  }
}
</script>

<style scoped>
.section-sub-menu {
  cursor: pointer;
}
.level-name {
  color: #9d9d9d;
}
</style>



// WEBPACK FOOTER //
// src/components/SectionSubMenu.vue